export default {
    name: "Viet Nam iRender Technology Joint Stock Company",
    address: "22 Thanh Cong Street, Thanh Cong Ward, Ba Dinh District, Ha Noi City, Viet Nam",
    workingTime: "Monday – Sunday / 9:00 AM – 8:00 PM GMT +7",
    hotline: {
        text: "+(84) 981-868-890",
        value: "+84962868890"
    },
    whatsapp: {
        text: "+(84) 981-868-890",
        value: "+84962868890"
    },
    skypeInternational: {
        name: "iRender International",
        id: "live:.cid.2197e8ed68cc0a0b"
    },
    skypeVietnam: {
        name: 'Skype Support',
        value: 'iRender Vietnam',
        id: "live:.cid.e7b1eaa67ba0a066"
    },
    zaloVietnam: {
        name: "Zalo Support",
        value: '+(84) 962-868-890',
        id: "+84962868890"
    },
    emailAddress: process.env.VUE_APP_EMAIL_SUPPORT,
    standardCharteredAccount: {
        accountName: 'VIET NAM IRENDER TECHNOLOGY JOINT STOCK COMPANY',
        bankName: "Standard Chartered Bank (Vietnam) Limited",
        swiftCode: "SCBLVNVX",
        bankBranch: "Le Dai Hanh Branch",
        bankAddress1: "CDC Building, 25 Le Dai Hanh,",
        bankAddress2: "Hai Ba Trung Dist., Ha noi, Vietnam",
        accountNo: {
            vn: {
                name: "VND",
                number: "66423385966",
            },
            us: {
                name: "USD",
                number: "66423385988",
            }
        }
    },
    vietcombankAccount: {
        accountName: 'VIET NAM IRENDER TECHNOLOGY JOINT STOCK COMPANY',
        bankBranch: "Vietcombank Bank Tayho Branch",
        accountNo: {
            vn: {
                name: "VND",
                number: "0991000222555",
            },
            us: {
                name: "USD",
                number: "0991370052930",
            }
        }
    },
}